module.exports = __webpack_public_path__ + "img/subt.55498470.svg";